import { RecordContextProvider, useGetOne } from "ra-core";

import { InviteAsClientButton } from "../contacts/InviteAsClientButton";
import type { Contact, Deal } from "../types";

/**
 * Invite the person behind a won deal.
 *
 * This is the moment the question actually comes up: the deal is won, the
 * project exists, and the client now needs somewhere to watch it. Rather than
 * duplicating the invite, it borrows the contact's own button by putting that
 * contact into record context -- so there is one invite flow, and it behaves
 * the same wherever it is offered.
 *
 * A deal carries several contacts; the first is the one it was opened against.
 */
export function InviteDealContactButton({ record }: { record: Deal }) {
  const contactId = record.contact_ids?.[0];

  const { data: contact } = useGetOne<Contact>(
    "contacts",
    { id: contactId! },
    { enabled: contactId != null },
  );

  if (!contact) return null;

  return (
    <RecordContextProvider value={contact}>
      <InviteAsClientButton />
    </RecordContextProvider>
  );
}
